import { GET_DEVICE_LIST, RESET_USER } from '../actions'

const INITIAL_STATE = {
    list: null,
    error: null,
}

function DeviceListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_DEVICE_LIST:
            return {
                ...state,
                [action.payload.body ? 'list' : 'error']: action.payload.body || action.payload,
            }
        case RESET_USER:
            return INITIAL_STATE
        default: return state
    }
}

export default DeviceListReducer



// WEBPACK FOOTER //
// ./src/reducers/deviceList.js